/* eslint-disable max-len */
const HOME = 'home';
const JOINT_POLICY_HOLDER_TITLE = 'jph';
const LANDLOAD_CONTENTS_TOTAL_VALUES = {
    up_to_fifty_thousand: 50000,
    up_to_twenty_five_thousand: 25000,
    up_to_ten_thousand: 10000
};
const CONTENTS_TOTAL_VALUES = {
    up_to_one_hundred_thousand: 100000,
    up_to_seventy_five_thousand: 75000,
    up_to_forty_thousand: 40000
};
const SG_HOME_CONTENTS_TOTAL_LIMITS = [75000, 100000];
const SG_HOME_CONTENTS_TOTAL_LIMITS_STRING = ['75,000', '100,000'];
const PERSONAL_BELONGINGS_VALUE = 10000;
const LANDLORD_BUILDINGS_UP_TO = 500000;
const SG_HOME_BUILDINGS_TOTAL_LIMITS = 1000000;
const FAQ_QUESTIONS_KEYS = ['contents', 'damage', 'renters', 'homeNotCovered', 'whyNeed'];

const BURGLAR_ALARM_OPTIONS = {
    YES_PROFESSIONAL_MAINTENANCE: 'yes-maintained',
    YES_NO_PROFESSIONAL_MAINTENANCE: 'yes-not-maintained',
    NO: 'no',
};

const SG_HOME_SPECIFIED_ITEM_LIMITS = {
    TAILORMADE_ART_LOWERBOUND: 15000,
    TAILORMADE_ITEM_LOWERBOUND: 5000
};

const COVERAGES_NAMES = {
    BUILDINGS: 'Building Cover',
    CONTENTS: 'Contents Cover'
};

const COVERAGES_CODES = {
    HomeEmergency: 'SPHSagaHomeEmergency',
    LegalExpenses: 'SPHLegalExpenses',
    LandlordLegalExpenses: 'SPHLandlordLegalExpenses',
    BoilerService: 'SPHBoilerService',
    HomeAndHeatingCover: 'HomeAndHeatingEmergency',
    RentGuarantee: 'SPHMonthlyRentGuarantee',
    Building: 'SPHBuildingCover',
    Contents: 'SPHContentsCover',
    PersonalBelongings: 'SPHPersonalBelongingsUnspecifiedItems',
    SpecifiedCoverAnywhere: 'SPHPersonalBelongingsSpecifiedItems',
    PersonalBelongingsCoverTotalValueTerm: 'SPHPersonalBelongingsUnspecifiedItemsTotalValue',
    ContentsCoverValuablesLimit: 'SPHContentsCoverValuablesLimit',
    HomeEmergencyTermName: 'SPHSagaHomeEmergencyCoverLevel',
    BuildingLevelTermName: 'SPHBuildingsCoverLevel',
    BuildingVolExcessTermName: 'SPHBuildingCoverVoluntaryExcess',
    BuildingSubsidenceExcessTermName: 'SPHBuildingCoverSubsidenceCompulsoryExcess',
    BuildingWaterExcessTermName: 'SPHBuildingCoverWaterCompulsoryExcess',
    ContentsSumInsuredTermName: 'SPHContentsCoverSumInsured',
    ContentsLevelTermName: 'SPHContentsCoverLevel',
    ContentsVolExcessTermName: 'SPHContentsCoverVoluntaryExcess',
    ContentsWaterExcessTermName: 'SPHContentsCoverWaterCompulsoryExcess',
    PersonalBelongingsTermName: 'SPHPersonalBelongingsUnspecifiedItemsTotalValue',
    HomeEmergencyHeatingTermOptionCode: 'SPHSagaHomeEmergencyCoverLevel_HomeAndHeatingEmergency',
    HomeEmergencyTermOptionCode: 'SPHSagaHomeEmergencyCoverLevel_HomeEmergency',
    CoverLevelSelect: 'SPHCover1',
    CoverLevelSelectAd: 'SPHCover2',
    CoverLevelPlus: 'SPHCover6',
};

const HOME_ADDONS = {
    HasHeatingCover: 'hasHeatingCover',
    HasBoilerCover: 'hasBoilerCover',
    HasSheCover: 'hasSheCover',
    HasLegalCover: 'hasLegalCover',
    HasContentsAccidentCover: 'hasContentsAccidentCover',
    HasBuildingsAccidentCover: 'hasBuildingsAccidentCover',
    UnspecifiedItemsCover: 'unspecifiedItemsCover'
};

const LOCKS_ON_DOORS_OPTIONS = {
    MORTICE_DEADLOCK: 'mortice-deadlock',
    RIM_AUTO_DEADLATCH: 'rim-auto-deadlatch',
    MULTIPOINT_LOCKING: 'multipoint-locking',
    OTHER: 'other'
};

const PROPERTY_USE_CODES = {
    Let: 'lo',
    LetHolidayHome: 'lh',
    FamilyHolidayHome: 'hh',
    WeekendHome: 'we'
};

const PROPERTY_CATEGORY_CODES = {
    HOUSE: 'house',
    BUNGALOW: 'bungalow',
    FLAT_MAISONETTE: 'flat_maisonette'
};

const IPID_PAGE_CONSTANTS = {
    PREMIER_CREDITCARD_VALUE: ['£1,000', '£500'],
    BUILDINGS_CONTENTS: 'buildings and contents',
    Contents: 'contents',
    Buildings: 'buildings',
    ToYour: 'to your',
    Damage: 'damage',
    LossOfOrDamage: 'loss of or damage',
    LossOrDamage: 'loss or damage',
    And: 'and',
    ContentsTitle: 'Contents',
    BuildingsTitle: 'Buildings',
    Title: 'Title',
    ProductTitle: 'ProductTitle',
    HOME: 'home',
    BuildingsAndContents: 'buildings_and_contents',
    Tailormade: 'tailor_made',
    InsuranceType: 'InsuranceType',
    InsuranceTypeDescCover: 'InsuranceTypeDescCover',
    PlusCover: 'Plus',
    InsuranceTypeDescCoverable: 'InsuranceTypeDescCoverable',
    Insured: 'insured',
    NotInsured: 'notInsured',
    Restrictions: 'restrictions',
    PhoneNumber: 'PhoneNumber',
    UnspecifiedandSpecified: 'Unspecified and Specified',
    Unspecified: 'Unspecified',
    Specified: 'Specified'
};

const SG_HOME_ERROR_REASONS = {
    PROPERTY_DIVIDED_INTO_BEDSITS: 9144,
    POLICY_CANCELLED_NON_PAYMENT: 9113,
    CUSTOMER_UNDER_50: 9117,
    LANDLORD_3_OR_MORE_WITH_SAGA: 9154,
    DECLINED_BUSINESS_USE_ASSUMPTIONS: 9155,
    INELIGIBLE_BUSINESS_USE_TYPE: 9143,
    NO_LANDLORD_TENANCY_AGREEMENT_OVER_6_MONTHS: 9156,
    FLOODING_AT_THE_PROPERTY: 9160,
    FLOOD_CLAIM: 9129,
    CONTENTS_VALUE_LESS_THAN_SEVENTY_FIVE_THOUSAND_AND_BUILDINGS_COVER_OVER_MILLION: 9147,
    SWITCHED_FROM_TAILORMADE_TO_STANDARD: 9149,
    CUSTOMER_IS_BANKRUPT_OR_HASCCJ: 9152,
    ZERO_PRICE: 9180
};

const SG_HOME_AVAILABLE_EXCESSES = [
    {
        name: '£50', value: 50, isTm: false, isLL: true
    },
    {
        name: '£100', value: 100, isTm: true, isLL: true
    },
    {
        name: '£150', value: 150, isTm: true, isLL: true
    },
    {
        name: '£200', value: 200, isTm: true, isLL: true
    },
    {
        name: '£250', value: 250, isTm: true, isLL: true
    },
    {
        name: '£300', value: 300, isTm: true, isLL: true
    },
    {
        name: '£350', value: 350, isTm: false, isLL: false
    },
    {
        name: '£400', value: 400, isTm: false, isLL: false
    },
    {
        name: '£450', value: 450, isTm: false, isLL: false
    },
    {
        name: '£500', value: 500, isTm: false, isLL: false
    },
    {
        name: '£700', value: 700, isTm: false, isLL: false
    },
    {
        name: '£1000', value: 1000, isTm: false, isLL: false
    }
];

// Property Use Types
const PROPERTY_USE_LET = 'lo';
const PROPERTY_USE_LET_HOLIDAY_HOME = 'lh';
const PROPERTY_USE_FAMILY_HOLIDAY_HOME = 'hh';
const PROPERTY_USE_WEEKEND_HOME = 'we';

const PROPERTY_OCCUPANTS_LODGERS = 'you_and_lodgers';
const PROPERTY_OCCUPANTS_OTHERS = 'others';
const PROPERTY_PATH = 'property';
const DAYS_UNOCCUPIED_THRESHOLD = '60';

const SG_HOME_TAILORMADE_LIMITS = {
    CONTENTS: 100000,
    REBUILD_COST: 1000000
};
const MAIN_RESIDENCE_USE_CODE = 'main_residence';

const COVER_LEVEL = {
    BUILDINGS_ONLY: 'buildings_only',
    CONTENTS_ONLY: 'contents_only',
    BUILDINGS_AND_CONTENTS: 'buildings_and_contents'
};

const COVER_TERMS = {
    HOME_INSURANCE: 'Saga Home Insurance',
    ESSENTIAL: 'Saga Essential Home',
    ESSENTIAL_WITH_AD: 'Saga Essential Home with  Accidental Damage'
};

const POLICY_BOOKLET_URLS = {
    SELECT_URL: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/home/saga-select-home-insurance-policy-book.pdf?cd=view',
    PLUS_URL: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/home/saga-plus-home-insurance-policy-book.pdf?cd=view',
    LANDLORD_URL: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/landlord/saga-landlord-insurance-policy-book.pdf?cd=view',
    TAILORMADE_URL: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/home/saga-tailormade-home-insurance-policy-book.pdf?cd=view',
    SHE_URL: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/home/saga-home-emergency-policy-book.pdf?cd=view',
    IMPORTANT_INFORMATION_URL: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/home/saga-home-insurance-important-information.pdf?cd=view',
    IMPORTANT_INFORMATION_URL_TAILORMADE: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/home/saga-tailormade-home-insurance-important-information.pdf?cd=view',
    IMPORTANT_INFORMATION_URL_LANDLORD: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/landlord/saga-landlord-insurance-important-information.pdf?cd=view',
};

const WHICH_LINK = 'https://www.which.co.uk/money/insurance/home-insurance/best-and-worst-home-insurance-atfzg4m93rm5?utm_campaign=recommendedprovider&utm_medium=endorsement&utm_source=Saga';

const PROPERTY_DETAILS = {
    FULL_DETAILS: 'FD',
    PARTIAL_DETAILS: 'PD',
    NO_DETAILS: 'ND',
};

const CLAIM_TYPE_CODES = {
    BUILDINGS_ONLY: 'BuildingsOnly',
    CONTENTS_ONLY: 'ContentsOnly',
    PERSONAL_BELONGINGS: 'PersonalBelongings',
};

const PRE_QUOTE_PAGE_URLS = ['/journey/property', '/journey/details', '/journey/specifiedItems', '/journey/your-property', '/journey/your-details', '/journey/your-cover'];

const PERSONAL_BELONGINGS_OPTIONS = {
    ZERO: 'zero'
};

export default {
    HOME,
    JOINT_POLICY_HOLDER_TITLE: JOINT_POLICY_HOLDER_TITLE,
    CONTENTS_TOTAL_VALUES: CONTENTS_TOTAL_VALUES,
    LANDLOAD_CONTENTS_TOTAL_VALUES: LANDLOAD_CONTENTS_TOTAL_VALUES,
    MORE_THAN_100K_KEY: 'more_than_one_hundred_thousand',
    UP_TO_75K_KEY: 'up_to_seventy_five_thousand',
    UP_TO_100k_KEY: 'up_to_one_hundred_thousand',
    UP_TO_40K_KEY: 'up_to_forty_thousand',
    FAQ_QUESTIONS_KEYS,
    SG_HOME_CONTENTS_TOTAL_LIMITS: SG_HOME_CONTENTS_TOTAL_LIMITS,
    BURGLAR_ALARM_OPTIONS: BURGLAR_ALARM_OPTIONS,
    LOCKS_ON_DOORS_OPTIONS: LOCKS_ON_DOORS_OPTIONS,
    NONE_PREFIX: 'zero',
    COVERAGES_NAMES,
    COVERAGES_CODES,
    TAILOR_MADE_PRODUCT_CODE: 'tailor_made',
    LANDLORD_PRODUCT_CODE: 'landlord',
    SG_HOME_AVAILABLE_EXCESSES: SG_HOME_AVAILABLE_EXCESSES,
    PROPERTY_USE_CODES,
    OCCUPANTS_YOU_AND_LODGERS: 'you_and_lodgers',
    COVER_LEVEL_HOMEAD: 'SPHCover2',
    COVER_LEVEL_SAGAPLUS: 'SPHCover6',
    PERSONAL_BELONGINGS_COVER: 'Personal Belongings Cover',
    NOT_AVAILABLE: 'NA',
    PROPERTY_USE_LET_HOLIDAY_HOME,
    PROPERTY_USE_FAMILY_HOLIDAY_HOME,
    PROPERTY_USE_WEEKEND_HOME,
    PROPERTY_USE_LET,
    SG_HOME_TAILORMADE_LIMITS,
    SG_HOME_CONTENTS_TOTAL_LIMITS_STRING,
    PERSONAL_BELONGINGS_VALUE,
    LANDLORD_BUILDINGS_UP_TO,
    SG_HOME_BUILDINGS_TOTAL_LIMITS,
    PROPERTY_OCCUPANTS_LODGERS,
    PROPERTY_OCCUPANTS_OTHERS,
    PROPERTY_PATH,
    DAYS_UNOCCUPIED_THRESHOLD,
    IPID_PAGE_CONSTANTS,
    SG_HOME_ERROR_REASONS,
    COVER_LEVEL: COVER_LEVEL,
    MAIN_RESIDENCE_USE_CODE,
    SG_HOME_SPECIFIED_ITEM_LIMITS,
    POLICY_BOOKLET_URLS,
    PROPERTY_CATEGORY_CODES,
    COVER_TERMS,
    WHICH_LINK,
    PROPERTY_DETAILS,
    HOME_ADDONS,
    CLAIM_TYPE_CODES,
    PRE_QUOTE_PAGE_URLS,
    PERSONAL_BELONGINGS_OPTIONS,
    HISCOX_TAILOR_MADE_PHONE_NUMBER: '0800 170 0346',
    UNDER_REBUILD_AMOUNT: 100000
};
